import styled from 'styled-components';
import ButtonGroup from 'react-bootstrap/ButtonGroup';

export const DisabledWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const DisabledTooltipBubble = styled.div`
  position: absolute;
  bottom: calc(100% + 0.6rem);
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 0.6rem 0.75rem;
  border-radius: ${(p) => p.theme.borderRadius};
  width: 13rem;
  font-size: ${(p) => p.theme.fontSizeSm};
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
  z-index: 1000;
  pointer-events: none;
  opacity: ${(p) => (p.$show ? 1 : 0)};
  transition: opacity 0.2s;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 0.4rem solid transparent;
    border-top-color: rgba(0, 0, 0, 0.9);
  }

  @media only screen and (max-width: ${(p) => p.theme.breakpointSm}) {
    left: auto;
    right: 0;
    transform: none;

    &::after {
      left: auto;
      right: 1rem;
      transform: none;
    }
  }
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  display: flex;
  justify-content: space-between;
  width: ${(props) => props.$width};
  height: 3rem;

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    height: 4.75rem;
    width: 100%;
  }
`;
